import businessIcon from '../assets/icons/LayoutIcons/business.svg';
import settingIcon from '../assets/icons/LayoutIcons/setting.svg';
import paymentIcon from '../assets/icons/LayoutIcons/payment.svg';
import getStartedIcon from '../assets/icons/LayoutIcons/get-started.svg';
import dashboardIcon from '../assets/icons/LayoutIcons/dashboard.svg';
import storeIcon from '../assets/icons/LayoutIcons/store.svg';
import balanceIcon from '../assets/icons/LayoutIcons/balance.svg';
import loanIcon from '../assets/icons/LayoutIcons/loans.svg';
export default [
  {
    title: 'Get started',
    icon: getStartedIcon,
    href: '/dashboard',
  },

  {
    title: 'Dashboard',
    icon: dashboardIcon,
    // slug: "/my-connections",
    href: '/my-dashboard',
  },
  {
    title: 'Business',
    icon: businessIcon,
    // slug: "/my-connections",
    href: '/my-business',
  },
  {
    title: 'Loans',
    icon: loanIcon,
    childrens: [
      {
        title: 'Loan application',
        href: '/loan/loan-application',
      },
      {
        title: 'Loan history',
        href: '/loan/loan-history',
        disabled: true,
      },
      {
        title: 'Business details',
        href: '/loan/loan-business',
        disabled: true,
      },
    ],
  },
  {
    title: 'Banking',
    icon: businessIcon,
    disabled: true,
    // slug: "/my-connections",
    // href: '/banking',
  },
  {
    title: 'Store',
    icon: storeIcon,
    disabled: true,
    childrens: [
      {
        title: 'Store Transactions',
        href: '/store/transactions',
      },
    ],
  },
  {
    title: 'Payments',
    icon: paymentIcon,
    disabled: true,
    // href: '/payment',
    childrens: [
      {
        title: 'Payment Links',
        href: '/payment/payment-link',
      },
      {
        title: 'Transactions',
        href: '/payment/transactions',
      },
      {
        title: 'Bank Accounts',
        href: '/payment/bank-account',
      },
      {
        title: 'Settlements',
        href: '/payment/settlements',
      },
      {
        title: 'Customers',
        href: '/payment/customers',
      },
      {
        title: 'Disputes',
        href: '/payment/disputes',
      },
    ],
  },

  {
    title: 'Balance',
    icon: balanceIcon,
    disabled: true,
    childrens: [
      {
        title: 'Balance',
        href: '/balance/account',
      },
    ],
  },
  {
    title: 'Settings',
    // disabled: true,
    icon: settingIcon,
    childrens: [
      {
        title: 'Profile Information ',
        href: '/settings/profile-information',
      },
      {
        title: 'Security ',
        href: '/settings/security',
      },

      {
        title: 'Business Information',
        href: '/settings/business-information',
      },
      {
        title: 'Reset Security Question',
        href: '/settings/reset-security-questions',
      },
      // {
      //   title: ' Payment Services ',
      //   href: '/settings/payment-services',
      // },
    ],
  },
];
